import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class ConnectionCriteria extends BasicCriteria {
kind: string;
}

